import { FlexProps } from '@chakra-ui/react'
import React from 'react'
import DefinitionListItem from './DefinitionListItem'
import DefinitionTerm from './DefinitionTerm'
import DefintionValue from './DefinitionValue'

interface DefinitionProps extends FlexProps {
  term: string | number
  definition: string | number
}

const Definition = ({ term, definition, ...baseProps }: DefinitionProps) => (
  <DefinitionListItem {...baseProps}>
    <DefinitionTerm>{term}</DefinitionTerm>
    <DefintionValue>{definition}</DefintionValue>
  </DefinitionListItem>
)

export default Definition
